import Styled from 'styled-components';
import {FlexColumn, Text} from '@forecast-it/design-system';

export const Form = Styled(FlexColumn)`
    width: 100%;
    gap: 16px;
`;

export const FullWidthField = Styled.div`
    width: 100%;
`;

export const ErrorText = Styled(Text)`
    color: #e0344b;
`;
